export const formatPercent = new Intl.NumberFormat('de-CH', {
  style: 'percent',
}).format;
